import { getPlatformFromApp } from 'libs/gutClient/electronBridge';

export const calcDesktopHeaderMarginLeft = async () => {
  const platform = await getPlatformFromApp();

  if (platform === 'darwin') {
    return '70px';
  }

  return 0;
};
